import React from 'react';
import Icon from '../components/ui/icon';

interface EmptyPageProps {
  title: string;
  icon: string;
  description?: string;
  parentTitle?: string;
}

const EmptyPage: React.FC<EmptyPageProps> = ({ 
  title, 
  icon, 
  description = "이 페이지는 아직 개발 중입니다.",
  parentTitle 
}) => {
  return (
    <div className="flex-1 flex flex-col items-center justify-center p-8">
      <div className="text-center space-y-4 max-w-md">
        {/* Icon and Title */}
        <div className="flex flex-col items-center space-y-3">
          <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center">
            <Icon name={icon} size={32} className="text-gray-400" />
          </div>
          <div>
            <h1 className="text-2xl font-bold text-gray-900">
              {title}
            </h1>
            {parentTitle && (
              <p className="text-gray-500 text-sm">
                {parentTitle} / {title}
              </p>
            )}
          </div>
        </div>
        
        {/* Empty State Message */}
        <div className="space-y-2">
          <p className="text-gray-600">
            {description}
          </p>
          <p className="text-gray-400 text-sm">
            곧 멋진 기능들로 채워질 예정입니다!
          </p>
        </div>

        {/* Optional placeholder for development */}
        <div className="mt-8 p-4 bg-gray-50 rounded-lg border-2 border-dashed border-gray-200">
          <p className="text-sm text-gray-500">
            개발자를 위한 영역
          </p>
          <p className="text-xs text-gray-400 mt-1">
            여기에 컴포넌트를 추가하세요
          </p>
        </div>
      </div>
    </div>
  );
};

export default EmptyPage;
